import SidePanelFormFooter from "@/modules/side-panel-form-footer";

import { useBatchTransitionFooter } from "./batch-transition-footer.hook";

const BatchTransitionFooter = () => {
  const { disabledSubmit, isLoading, isFinished, onSubmitClick } =
    useBatchTransitionFooter();

  return (
    <SidePanelFormFooter
      closeType={isFinished ? "close" : "cancel"}
      hideSubmit={isFinished}
      submitProps={{
        disabled: disabledSubmit,
        loading: isLoading,
        onClick: onSubmitClick,
      }}
    />
  );
};

export default BatchTransitionFooter;
